(function () {
  function cleanText(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .replace(/[^\p{L}\p{N}\s]/gu, "")
      .trim();
  }

  function findReviewCards() {
    const selectors = [
      ".jdgm-rev",
      ".spr-review",
      ".loox-review",
      ".review",
      ".review-card",
      ".customer-review",
      ".product-review",
      "[data-review-id]",
      "[data-review-card]",
      "[class*='review-item']",
      "[class*='review_card']"
    ];

    const cards = new Set();

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        cards.add(element);
      });
    });

    return Array.from(cards);
  }

  function removeDuplicateReviews() {
    const cards = findReviewCards();
    const seen = new Set();

    cards.forEach((card) => {
      const fullText = cleanText(card.innerText);

      if (!fullText || fullText.length < 30) {
        return;
      }

      if (seen.has(fullText)) {
        card.style.display = "none";
        card.setAttribute("data-terk-duplicate-review", "true");
      } else {
        seen.add(fullText);
      }
    });
  }

  function startCleaner() {
    removeDuplicateReviews();

    let timer;

    const observer = new MutationObserver(() => {
      clearTimeout(timer);

      timer = setTimeout(() => {
        removeDuplicateReviews();
      }, 300);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => {
      observer.disconnect();
    }, 30000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startCleaner);
  } else {
    startCleaner();
  }
})();